module.exports = __webpack_public_path__ + "img/5.b05c3b81.jpg";